import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import InterestsApi from '@infrastructure/interests-api';
export const getAllInterestsAsync = createAsyncThunk('interests/getAll', async (payload, { rejectWithValue }) => {
    try {
        const response = await InterestsApi.getAllInterests(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllInterestsWithoutPaginationAsync = createAsyncThunk('interests/getAllWithoutPagination', async (_, { rejectWithValue }) => {
    try {
        const response = await InterestsApi.getAllInterestsWithoutPagination();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createInterestAsync = createAsyncThunk('interests/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await InterestsApi.createInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateInterestAsync = createAsyncThunk('interests/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await InterestsApi.updateInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteInterestAsync = createAsyncThunk('interests/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await InterestsApi.deleteInterest(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInterestByIdAsync = createAsyncThunk('interests/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InterestsApi.getInterestById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
